module.exports = "<p class=\"title\">\n    <ng-content></ng-content>\n</p>"